import { useMutation } from '@tanstack/react-query'
import { UserController } from 'src/controllers/user.controller'
import { LoginResponse } from 'src/contexts/auth/types'

const userController = new UserController()

export function useRegisterUser() {
  return useMutation<LoginResponse, Error, string>({
    mutationKey: ['registerUser'],
    mutationFn: (username: string) => userController.registerUser(username)
  })
}
